{
  "dss": {
    "button": {
      "back": "Kembali",
      "cancel": "Batal",
      "close": "Tutup",
      "confirmDelete": "Ya, hapus",
      "continue": "Lanjut",
      "logout": "Keluar",
      "passwordReset": "Atur Ulang Kata Sandi",
      "save": "Simpan",
      "verify": "Verifikasi"
    },
    "error": {
      "403": "Anda tidak memiliki akses ke halaman ini.",
      "404": "Halaman ini tidak ada.",
      "generic": "Terjadi kesalahan. Silakan coba lagi nanti.",
      "throttling": "Terlalu banyak percobaan. Operasi ini diblokir sementara.",
      "title": "Error",
      "title403": "Akses ditolak",
      "title404": "Tidak ditemukan"
    },
    "footer": {
      "imprint": "Imprint",
      "legalEntity": "ANDREAS STIHL AG & Co. KG, D-71336 Waiblingen",
      "privacy": "Kebijakan Privasi",
      "terms": "Syarat & Ketentuan"
    },
    "label": {
      "CRMAccountNumber": "Nomor Akun CRM",
      "contact": "Kontak",
      "email": "Email",
      "faq": "FAQ",
      "female": "Nona",
      "firstname": "Nama depan",
      "help": "Bantuan",
      "language": "Bahasa",
      "lastname": "Nama belakang",
      "male": "Tuan",
      "needHelp": "Butuh bantuan?",
      "newPassword": "Kata sandi baru",
      "newPassword2": "Konfirmasi kata sandi baru",
      "oldPassword": "Kata sandi saat ini",
      "organization": "Organisasi",
      "password": "Kata sandi",
      "required": "wajib",
      "salutation": "Sapaan",
      "select": "Silakan pilih"
    },
    "lang": {
      "de": "Jerman"
    },
    "link": {
      "contact": "https://support.stihl.com/de-DE/websso-contact/",
      "faq": "https://support.stihl.com/de-DE/externalkbsearchwebsso/"
    },
    "page": {
      "confirm": {
        "title": "Konfirmasi Pendaftaran",
        "wait": "Harap tunggu hingga konfirmasi akun selesai."
      },
      "otp": {
        "btnResend": "Kirim ulang email kode verifikasi",
        "msg": {
          "invalidOTP": "Kata sandi satu kali yang dimasukkan tidak valid.",
          "resendFail": "Gagal mengirim ulang kode. Silakan coba lagi nanti."
        },
        "spamDetail": "Periksa kotak masuk atau folder spam Anda untuk email dari STIHL Support (noreply@stihl-sso.com)",
        "spamTitle": "Tidak menerima email?",
        "subtitle": "Untuk mengatur ulang kata sandi, Anda harus memverifikasi alamat email.",
        "title": "Verifikasi akun Anda",
        "txtVerifyMail": "Masukkan kode verifikasi baru yang dikirim ke alamat email {email}"
      },
      "personal": {
        "msg": {
          "noChange": "Tidak ada perubahan untuk disimpan.",
          "updateError": "Informasi pribadi tidak dapat disimpan.",
          "updated": "Informasi pribadi telah disimpan.",
          "userLoadErr": "Terjadi kesalahan. Silakan coba lagi nanti!"
        },
        "secOrganization": "Organisasi",
        "secPersonal": "Pribadi",
        "secSettings": "Preferensi",
        "title": "Informasi Pribadi"
      },
      "postPwSet": {
        "info": "Mulai sekarang Anda dapat menggunakan kata sandi baru untuk masuk.",
        "link_name": "Lanjut ke portal dealer",
        "link_url": "https://b2bportal.stihl.de",
        "title": "Kata sandi Anda telah diatur ulang"
      },
      "resetPW": {
        "title": "Atur ulang kata sandi Anda"
      },
      "security": {
        "2fa": {
          "availableMethods": "Metode 2FA yang tersedia:",
          "info": "Autentikasi dua faktor (2FA) adalah fitur keamanan yang menambahkan lapisan perlindungan tambahan ke akun Anda. Ini mengharuskan Anda menggunakan dua metode untuk masuk, bukan hanya nama pengguna dan kata sandi.",
          "method": {
            "email": "Email",
            "emailDesc": "Terima kode sekali pakai melalui email untuk menyelesaikan permintaan autentikasi.",
            "oath": {
              "add": {
                "button": "Daftarkan aplikasi autentikator"
              }
            }
          }
        },
        "authenticator": "Aplikasi Autentikator",
        "infoFederatedAccount": "Akun ini dikelola oleh penyedia identitas organisasi Anda, sehingga kata sandi tidak dapat diubah di sini. Untuk mengubah kata sandi Anda, masuk melalui halaman login organisasi Anda atau hubungi administrator TI Anda.",
        "lastUse": "Terakhir digunakan pada {0}.",
        "msg": {
          "invalidPassword": "Kata sandi lama tidak valid.",
          "passwordAlreadyUsed": "5 kata sandi terakhir tidak boleh digunakan kembali.",
          "pwUpdateError": "Kata sandi tidak dapat disimpan.",
          "pwUpdated": "Kata sandi telah diubah."
        },
        "noDevice": "Tidak dikonfigurasi",
        "oathAdd": {
          "appInfo": "Untuk mempermudah proses masuk ke STIHL, Anda dapat menggunakan aplikasi autentikator seperti {0}, {1} atau {2}, dll. untuk menghasilkan kata sandi satu kali yang digunakan sebagai faktor kedua selama proses masuk.<br/>Jika Anda kehilangan atau lupa perangkat seluler Anda, Anda selalu dapat menggunakan kode 2FA lama yang dikirim melalui email.<br/><br/>Silakan ikuti instruksi di bawah ini untuk menyiapkan metode 2FA di perangkat seluler Anda.",
          "badCode": "Kode tidak valid, silakan coba lagi.",
          "error": "Terjadi kesalahan saat mencoba mendaftarkan perangkat autentikasi.",
          "headScan": "1. Pindai kode QR dengan aplikasi autentikator Anda",
          "headVerify": "2. Verifikasi kode",
          "infoKey": "Kunci penyiapan",
          "infoKeyTitle": "Rahasia dua faktor Anda",
          "infoScanBottom": "Tidak bisa memindai? Anda dapat menggunakan {0} untuk mengonfigurasi aplikasi autentikator secara manual.",
          "infoVerify": "Masukkan kode yang dihasilkan oleh aplikasi autentikator Anda.",
          "success": "Perangkat autentikasi Anda telah didaftarkan. Anda dapat menggunakannya untuk masuk.",
          "title": "Daftarkan perangkat autentikasi dua faktor"
        },
        "oathDelete": {
          "error": "Terjadi kesalahan saat mencoba menghapus perangkat autentikasi.",
          "success": "Perangkat autentikasi telah dihapus."
        },
        "passkeys": {
          "about": {
            "info1": "Passkey adalah pasangan kunci kriptografi (kunci publik dan kunci privat) yang disimpan oleh sebuah autentikator yang Anda kendalikan. Autentikator dapat membuktikan bahwa pengguna hadir dan berwenang menggunakan passkey tersebut. Autentikator dapat melakukan otorisasi dengan PIN, kode, biometrik, atau kata sandi perangkat, bergantung pada kemampuan dan konfigurasinya. Autentikator hadir dalam berbagai bentuk, seperti iPhone, perangkat Android, Windows Hello, kunci keamanan perangkat keras FIDO2, atau pengelola kata sandi.",
            "info2": "Saat Anda masuk ke STIHL menggunakan passkey, autentikator Anda menggunakan kriptografi kunci publik untuk membuktikan identitas Anda ke STIHL tanpa pernah mengirimkan passkey. Passkey terikat dengan domain situs web seperti stihl-sso.com dan memerlukan koneksi yang aman, sehingga browser akan menolak autentikasi pada situs phishing tiruan. Sifat ini membuat passkey sangat tahan terhadap phishing dan jauh lebih sulit diserang dibandingkan SMS atau 2FA TOTP yang rentan phishing.",
            "info3": "Layanan passkey berbasis cloud memungkinkan sinkronisasi passkey di berbagai perangkat (misalnya perangkat Apple, perangkat Android, atau pengelola kata sandi), sehingga dapat digunakan dari beberapa tempat dan lebih kecil kemungkinan hilang. Setelah Anda menyiapkan passkey tersinkron di satu perangkat, passkey tersebut tersedia di beberapa perangkat yang menggunakan layanan yang sama. Misalnya, jika Anda mendaftarkan passkey dengan akun iCloud melalui Touch ID di MacBook, Anda dapat menggunakan passkey tersebut selanjutnya dengan wajah, sidik jari, PIN, atau kata sandi perangkat di beberapa perangkat yang terhubung ke akun iCloud yang sama.",
            "title": "Tentang Passkey"
          },
          "add": {
            "button": "Tambahkan passkey baru",
            "error": "Terjadi kesalahan saat mencoba menambahkan passkey baru.",
            "success": "Passkey baru telah ditambahkan."
          },
          "delete": {
            "button": "Hapus passkey",
            "error": "Terjadi kesalahan saat mencoba menghapus passkey ini.",
            "success": "Passkey telah dihapus."
          },
          "edit": {
            "error": "Terjadi kesalahan saat mencoba menyimpan nama passkey.",
            "name": "Nama passkey",
            "success": "Nama passkey telah diperbarui.",
            "title": "Beri nama pada passkey Anda untuk membedakannya dari passkey lainnya"
          },
          "info": "Passkey adalah alternatif yang mudah dan aman untuk kata sandi. Passkey memvalidasi identitas Anda menggunakan sentuhan, pengenalan wajah, kata sandi perangkat, atau PIN.",
          "none": "Tidak ada passkey yang dikonfigurasi.",
          "reallyDelete": "Yakin ingin menghapus passkey?",
          "registeredPasskeys": "Passkey yang terdaftar:",
          "title": "Passkey"
        },
        "reallyDeleteDevice": "Yakin ingin menghapus perangkat autentikasi?",
        "secMFA": "Autentikasi Multi-Faktor",
        "secPwdChange": "Ubah kata sandi",
        "title": "Masuk dan keamanan"
      },
      "setPW": {
        "acceptTC": "Harap konfirmasi {terms} kami dan baca {privacy} kami",
        "killSSO": "Batalkan semua sesi aktif",
        "msg": {
          "tokenExpired": "Tautan atau kode kata sandi telah kedaluwarsa. Silakan ikuti tautan untuk mengatur ulang kata sandi Anda: {link}."
        },
        "privacy": "Kebijakan Privasi",
        "terms": "Syarat & Ketentuan",
        "title": "Masukkan kata sandi baru"
      }
    },
    "validations": {
      "hasDigit": "Harus mengandung angka",
      "hasLowercase": "Harus mengandung huruf kecil.",
      "hasSpecial": "Harus mengandung karakter khusus: {chars}",
      "hasUppercase": "Harus mengandung huruf besar",
      "invalidCharacters": "Mengandung karakter tidak valid",
      "maxLength": "Maksimal {max} karakter diizinkan",
      "minLength": "Minimal {min} karakter diperlukan",
      "notSameAsEmail": "Terlalu mirip dengan alamat email",
      "onlyValidCharactersAllowed": "Hanya huruf, angka, dan spasi yang diperbolehkan.",
      "required": "Wajib",
      "sameAsPassword": "Kata sandi tidak cocok!",
      "tcAccepted": "Harap konfirmasi S&K kami.",
      "validEmail": "Alamat email tidak valid.",
      "validOTP": "Silakan masukkan kode verifikasi."
    }
  }
}
